import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";
import useSWR from "swr";


export const useAdminGetSkillsSWR= (active = null) => {
    const protectedApi = useProtectedAPI();
    const fetcher = (url) => protectedApi.get(url).then((res) => res.data);

    const url = active ? `/admin/skills?active=${active}` : "/admin/skills"

    const { data, error, isLoading, isValidating, mutate } = useSWR(url, fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminGetSkills= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetSkills = (filters) => {
        const queryString = objectToQueryString(filters)
        const url = `/admin/skills?${queryString}`
        const promise = protectedAPI.get(url).then(response => {
            return {
                data: response.data,
                total: response.headers["x-total-count"]
            }
        })

        return {
            then: (resolve, reject) =>
                promise.then(result => resolve(result.data), reject),
            catch: (reject) =>
                promise.catch(reject),
            withTotal: () =>
                promise.then(result => [result.data, result.total])
        }

    }
    
    return adminGetSkills
}



export const useAdminGetSkill= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetSkill = async (id) => {
        const response = await protectedAPI.get(`/admin/skills/${id}`)
        return response.data
    }

    return adminGetSkill
}



export const useAdminCreateSkill= () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateSkill = async (data) => {
        const response = await protectedAPI.post(`/admin/skills`, data)
        return response.data
    };

    return adminCreateSkill;
}



export const useAdminUpdateSkill= () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateSkill = async (id, data) => {
        const response = await protectedAPI.put(`/admin/skills/${id}`, data)
        return response.data
    };

    return adminUpdateSkill;
}



export const useAdminDeleteSkill= () => {
    const protectedAPI = useProtectedAPI();

    const adminDeleteSkill = async (id) => {
        const response = await protectedAPI.delete(`/admin/skills/${id}`)
        return response.data
    };

    return adminDeleteSkill;
}
